<template>
  <div class="wrapper-explanation-block">
    <TitleBar :title="title" />

    <div class="content">
      <WmSanitizeHtml
        class="content-text" tag="p"
        :innerHtml="content"
      />

      <div
        class="content-img"
        v-if="!isStepOne"
      >
        <img
          v-for="item in imgList"
          :key="item"
          :src="item"
          :alt="item"
        >
      </div>

      <div
        v-else
        class="step-one-content"
      >
        <img
          class="step-one-content-img"
          src="~@/assets/img/huawei-download-explanation/app-logo.png"
          alt="app-logo.png"
        >

        <span>{{ $t('huawei.appName') }}</span>
      </div>
    </div>
  </div>
</template>


<script>
import TitleBar from './title-bar.vue';
import WmSanitizeHtml from '@/components/wm-sanitize-html';

export default {
  name: 'ExplanationBlock',

  components: {
    TitleBar,
    WmSanitizeHtml,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    content: {
      type: String,
      default: '',
    },

    imgList: {
      type: Array,
      default: () => [],
    },

    isStepOne: {
      type: Boolean,
      default: false,
    },
  },
};
</script>


<style lang="less" scoped>
.wrapper-explanation-block {
  width: 100%;
  margin-bottom: 48px;

  .content {
    margin-top: 6px;

    .content-text {
      margin: 0;
      padding: 0;
      color: #14223d;
      font-size: 14px;
      font-weight: 300;
      line-height: normal;
      word-break: break-word;
    }

    ::v-deep .link {
      color: #365AA4;
      text-decoration: none;
      word-break: break-all;
    }

    .content-img {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      img {
        flex-shrink: 0;
        width: calc(50% - 8px);
        height: 100%;
        margin-top: 16px;
        object-fit: cover;
      }
    }

    .step-one-content {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 100%;
      height: 72px;
      margin-top: 16px;
      padding: 12px 20px;
      color: #000;
      font-size: 15px;
      line-height: normal;
      background-color: #fff;
      border-radius: 12px;

      .step-one-content-img {
        width: 48px;
        height: 100%;
        margin-right: 12px;
      }
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
